var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { Box, TermsAndConditions } from '@telus-uds/components-web';
import styled from 'styled-components';
import { PageSection } from '../../../components/PageSection/PageSection';
import { richTextWithPlainString } from '../../../helpers/richText';
import LegalContext from '../store/legal-context';
var NittyGritty = function (_a) {
    var _b;
    var copyValues = _a.copyValues;
    var _c = useContext(LegalContext), legalList = _c.legalList, language = _c.language;
    var _d = useState(false), mounted = _d[0], setMounted = _d[1];
    var legalNittyGrittyText = copyValues.legalNittyGrittyText, hideLegalNittyGrittyText = copyValues.hideLegalNittyGrittyText;
    // Ensures the HTML tree is consistent between server side and client side rendering.
    useEffect(function () {
        setMounted(true);
    }, []);
    return (mounted &&
        (legalList === null || legalList === void 0 ? void 0 : legalList.length) > 0 && (_jsx(PageSection, { id: "nitty-gritty", children: _jsx(Box, { vertical: 4, children: _jsx(StyledTermsAndConditionsWrapped, { children: _jsx(TermsAndConditions, { copy: language, dictionary: (_b = {},
                        _b[language] = {
                            headingHide: hideLegalNittyGrittyText,
                            headingView: legalNittyGrittyText,
                            nonIndexedTitle: legalNittyGrittyText
                        },
                        _b), indexedContent: legalList.map(function (legal) {
                        return richTextWithPlainString(legal.content);
                    }) }) }) }) })));
};
NittyGritty.displayName = 'NittyGritty';
var StyledTermsAndConditionsWrapped = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ol,\n  ul {\n    list-style: auto !important;\n  }\n"], ["\n  ol,\n  ul {\n    list-style: auto !important;\n  }\n"])));
export default NittyGritty;
var templateObject_1;
